import React from "react";
import { connect } from "react-redux";
import { XS_MOBILE, SM_MOBILE, MD_TABLET } from "../../../../constants/textConstants";
import { Icon, Typography } from "../../../ecosystem";
import SummaryItemFile from "./SummaryItemFile";

const SummaryItem = ({
    fileName,
    fileSize,
    info,
    title,
    screenBreakPoint,
    variant
}) => {

    const isMobile = ([XS_MOBILE, SM_MOBILE]).indexOf(screenBreakPoint) > -1 ? true : false;

    return (
        <div className="care-gaps-summary-item">
            {variant && variant ==='file'
                ? <SummaryItemFile
                    fileName={fileName}
                    fileSize={fileSize}
                />
                : <div className="care-gaps-summary-item__content care-gaps-summary-item__content--default">
                    {title &&
                        <div className="care-gaps-summary-item__content-title">
                            <Typography
                                bold
                                color={isMobile ? "$color-secondary-a2" : "$color-primary-a3"}
                                type={isMobile ? "body-02" : "heading-02"}
                                responsive
                            >
                                {title}
                            </Typography>
                        </div>
                    }
                    {info && info !== "undefined" &&
                        <div className="care-gaps-summary-item__content-info">
                            <Typography
                                color={"$color-secondary-a2"}
                                type={isMobile ? "meta-01" : "body-01"}
                                responsive
                            > {info}
                            </Typography>
                        </div>
                    }
                </div>
            }
            
            <div className="care-gaps-summary-item__icon">
                <Icon name="check" color={"$color-system-a1"} />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        screenBreakPoint: state.common.screenBreakPoint
    }
};

export default connect(mapStateToProps, null)(SummaryItem);